require(["jquery"], function ($) {
  "use strict";

  function showNewsletterPopup() {
    $(".newsletter-popup").addClass("is_active");
    $(".js_close-nlpopup").focus();
  }

  if (
    document.cookie.indexOf("ewsletter-popup=") <= 0 &&
    $("#travelclick-nl-popup").data("active") == true
  ) {
    setTimeout(function () {
      showNewsletterPopup();
    }, 45000);
  }

  $(document).on("submit", "#mc-embedded-subscribe-form", function (e) {
    e.preventDefault();
    var form = $("#mc-embedded-subscribe-form");
    if ($(".newsletter-popup").find(".checkbox-newsletter").prop("checked")) {
      $(".checkbox-newsletter").removeClass("error");
      var valid = true;
    } else {
      $(".checkbox-newsletter").addClass("error");
      var valid = false;
    }
    if (valid) {
      $.ajax({
        type: "POST",
        url: form.attr("action"),
        data: form.serialize(),
        dataType: "jsonp",
        contentType: "application/json",
        jsonpCallback: "callback",
        success: function (data) {
          if (data.result != "error") {
            // console.log('success');
            // console.log(data);
            $(".newsletter-thx").addClass("is_visible");
            $("#mc-embedded-subscribe-form").addClass("is_hidden");
            $(".js_subscribe").addClass("is_hidden");
            $(".newsletter-error").removeClass("is_visible");
            $(".promoinfo").addClass("is_hidden");
          } else {
            // console.log('error');
            // console.log(data);
            $(".newsletter-thx").removeClass("is_visible");
            $(".newsletter-error").append(data.msg);
            $(".newsletter-error a").attr("target", "_blank");
            $(".newsletter-error").addClass("is_visible");
          }
        },
        error: function (error) {
          // console.log('error() => error: ');
          // console.log(data);
        },
        always: function (data) {
          // console.log(data);
        },
      });
    } else {
      // console.log('not valid');
    }
  });

  $(document).on("click", ".js_close-nlpopup", function () {
    $(".newsletter-popup").removeClass("is_active");

    var d = new Date();
    // console.log(d);

    d.setTime(d.getTime() + 365 * 24 * 60 * 60 * 1000);
    // console.log(d);

    var expires = d.toUTCString();
    // console.log(expires);

    document.cookie =
      "newsletter-popup=confirmed; expires=" + expires + "; path=/";
    // console.log(document.cookie);
  });

  $(".newsletter-popup input[type=email]").change(function () {
    if ($(this).val()) {
      $(this).siblings(".email-label").addClass("hidden");
    } else {
      $(this).siblings(".email-label").removeClass("hidden");
    }
  });

  $(".newsletter-popup input[type=text]").change(function () {
    if ($(this).val()) {
      $(this).siblings(".text-label").addClass("hidden");
    } else {
      $(this).siblings(".text-label").removeClass("hidden");
    }
  });

  $("[href=#newsletter]").on("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    showNewsletterPopup();
  });
});

define("root/Assets/Templates/Html/FullFooter/Js/FullFooter", function(){});

